import { FetchApi} from '../lib/anuket-http';
import { configs } from '../configs';
import eventBus from '../lib/event-bus-rx';

/**
 * Fetch courses
 */
export function fetchCourse() {
  return eventBus.getTopic('athlinksId').flatMap(getExtraData);
}

/**
 * Get extra data for event
 * @param eventId
 */
export function getExtraData(eventId) {
  return FetchApi
    .doFetch(`${configs.ATHLINKS_API_HOST}/events/api/${eventId}/extra`, {})
    .map(({ result }) => result ? result : {});
}

/**
 * Get courses for an event
 */
export function loadEventCourses() {
  return eventBus.getTopic('athlinksId').flatMap((athlinksId) =>
    FetchApi
      .doFetch(`${configs.ATHLINKS_API_HOST}/Events/Race/Api/${athlinksId}/Course/0`)
      .map(({ Result }) =>
          Result,
      ))
}



/** WEBPACK FOOTER **
 ** ./data/ExtraEventStream.js
 **/